import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckCancelledPage } from './pages/check-cancelled/check-cancelled.component';
import { DynamicPagePage } from './pages/dynamic-page/dynamic-page.page';
import { InvalidComponent } from './pages/invalid/invalid.component';
import { LoginPage } from './pages/login/login.page';
import { RefereeThankyouPage } from './pages/referee-thankyou/referee-thankyou.component';
import { RefereePageComponent } from './pages/referee/referee.page';
import { ReferencingPage } from './pages/referencing/referencing.page';
import { RouteParameters, RouteReservedPrefix } from './constants/route-reserved-prefix';
import { InterviewsPage } from './pages/interviews/interviews.page';
import { InterviewListViewPage } from './pages/interviews/pages/interview-list-view/interview-list-view.page';
import { InterviewDetailsPage } from './pages/interviews/pages/interview-details/interview-details.page';
import { CanAccessOnboardingGuard } from './guards/can-access-onboarding.guard';
import { CanAccessInterviewsGuard } from './guards/can-access-interviews.guard';
import { CanAccessReferencingGuard } from './guards/can-access-referencing.guard';

const routes: Routes = [
  {
    path: RouteReservedPrefix.LOGIN,
    component: LoginPage
  },
  {
    path: RouteReservedPrefix.REFERENCING,
    component: ReferencingPage,
    canActivate: [CanAccessReferencingGuard]
  },
  {
    path: RouteReservedPrefix.REFEREE,
    component: RefereePageComponent
  },
  {
    path: RouteReservedPrefix.INTERVIEWS,
    component: InterviewsPage,
    canActivate: [CanAccessInterviewsGuard],
    children: [
      {
        path: ``,
        component: InterviewListViewPage
      },
      {
        path: `details/:${RouteParameters.INTERVIEW_ID}`,
        component: InterviewDetailsPage
      }
    ]
  },
  {
    path: RouteReservedPrefix.CANCELLED,
    component: CheckCancelledPage
  },
  {
    path: RouteReservedPrefix.THANKYOU,
    component: RefereeThankyouPage
  },
  {
    path: RouteReservedPrefix.INVALID,
    component: InvalidComponent
  },
  {
    path: '**',
    component: DynamicPagePage,
    canActivate: [CanAccessOnboardingGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
